import s from './collegesItem.module.css'
import styleFilter from '../FilterList/FilterList.module.css'
import { useState, useEffect, Fragment } from 'react'
import { useGetNameRole } from '@helpers/useGetNameRole'
import { getAvatar } from '@helpers/getAvatar'
import { useScreenWidth } from '@hooks/useScreenWidth'
import {
  EditIcoNewDesign,
  ExpandDropDownList,
  PlusIcon,
  DeleteIconEmployees,
} from '@/utils/icons'
import { useInputNew } from '@UI/InputNew/useInputNew'
import { DatePicker, Space } from 'antd'
import { InputSelect } from '@UI/InputNew'
import { useAddAlert } from '@/hooks/useAddAlert'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import {
  workingHours,
  usersAPI,
  departments as departmentsApi,
  teams as teamsApi,
} from '@/api'
import Modal from '@common/Modal'
import ModalAddTime from './modals/ModalAddTime'
import ModalAddContracts from './modals/ModalAddContracts'
import ModalEditAva from './modals/ModalEditAva'
import ModalAddDepartments from './modals/ModalAddDepartments'
import ModalAddTeams from './modals/ModalAddTeams'
import ModalAddRole from './modals/ModalAddRole'
import ModalChengeVks from './modals/ModalChengeVks'
import ModalAddDirection from './modals/ModalAddDirection'
import ModalRecoverPassword from './modals/ModalRecoverPassword'
import ModalAddGroup from './modals/ModalAddGroup'
import { getInArr } from '@/helpers/getInArr'
import { IcoRemove } from '@pages/Admin/constsIcon'
import { useDispatch, useSelector } from 'react-redux'
import { actionUpdProfile, selectProfile } from '@store/profile.reducer'
import { AuthService } from '@/services/AuthService'
import Preloader from '@UI/Preloader'
import { formateDate } from '@helpers/date'
import setSettingsFromServer from '@/helpers/setSettingsFromServer'
import Tooltip from '@UI/Tooltip'
import { useGetSettings } from '@pages/CoursesCatalog/tabs/CatalogCoursesTab/hooks/getPlatformSettings'
import SeniorSeminaristResponsibilitySelect from '../modals/CreateColleague/components/SeniorSeminaristResponsibilitySelect/SeniorSeminaristResponsibilitySelect'
import UpdateSeniorSeminarianSupervision from './modals/UpdateSeniorSeminarianSupervision/UpdateSeniorSeminarianSupervision'
import EmailVerifyWrapper from '@common/EmailVerifyWrapper/EmailVerifyWrapper'
import classNames from 'classnames'
dayjs.extend(customParseFormat)

let rateChangeTimeoutGroup1 = null
let rateChangeTimeout1 = null
export const CollegesItemEdit = ({ setEdit, edit, setState, big }) => {
  const { checkSettings } = useGetSettings()
  const showGender = checkSettings('showGenderColleagues')
  const showBirthDate = checkSettings('showBirthDateColleagues')
  const showCity = checkSettings('showCityColleagues')
  const showRegistrationAddress = checkSettings(
    'showRegistrationAddressColleagues',
  )
  const showEducation = checkSettings('showEducationColleagues')
  const showWorkExperience = checkSettings('showWorkExperienceColleagues')
  const showSocialLink = checkSettings('showSocialLinkColleagues')
  const showVksLink = checkSettings('showVksLinkColleagues')
  const isSeparateLinksForStudentsAndTeachers = checkSettings(
    'isSeparateLinksForStudentsAndTeachers',
  )
  const showAboutMe = checkSettings('showAboutMeColleagues')
  const showDepartments = checkSettings('showDepartmentsColleagues')
  const showWorkSchedule = checkSettings('showWorkScheduleColleagues')
  const showContracts = checkSettings('showContractsColleagues')
  const seniorSeminarianManager = checkSettings(
    'isSeniorSeminarianManageCoursesClasses',
  )

  const roleAndDepartmentsText = showDepartments ? 'Роли и отделы' : 'Роли'

  const [settings, setSettings] = useState({})
  useEffect(() => {
    setSettingsFromServer(setSettings)
  }, [])
  const userIdsAllowedToDeleteEmployee = settings.userIdsAllowedToDeleteEmployee
    ? JSON.parse(settings.userIdsAllowedToDeleteEmployee)
    : []
  const selectEmployeesWhoAreAllowedDeleteEmployees =
    settings.selectEmployeesWhoAreAllowedDeleteEmployees === '1'

  const [user, setUser] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    usersAPI
      .getUser({
        id: edit,
        expand: [
          'roles',
          'contracts',
          'userProfile',
          'workHours',
          'orgUnits.head',
          'teams.head',
          'groups_supervisor',
          'classes_supervisor',
        ],
      })
      .then((res) => {
        setUser(res.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [edit])

  const profile = useSelector(selectProfile)
  const allowEditing =
    profile?.role === 'admin' ||
    profile?.role === 'hr-manager' ||
    profile?.role === 'junior-admin'

  const dispatch = useDispatch()

  const addAlert = useAddAlert()

  const dateFormat = 'YYYY.MM.DD'
  const isMobile = useScreenWidth(767)

  const [name, setName] = useState(user?.name ?? '')
  const [departments, setDepartments] = useState(user?.orgUnits ?? [])
  const [teams, setTeams] = useState(user?.teams ?? [])
  const [contracts, setContracts] = useState(user?.contracts ?? [])
  const [userId, setUserId] = useState(user?.id)
  const [phone, setPhone] = useState(user?.phone ?? '')
  const [email, setEmail] = useState(user?.email ?? '')
  const [sex, setSex] = useState(user?.userProfile?.sex)
  const [birthDate, setBirthDate] = useState(
    user?.userProfile?.birth_date ?? '2000.01.01',
  )
  const [birthDateDefault, setBirthDateDefault] = useState(
    user?.userProfile?.birth_date ?? '2000.01.01',
  )
  const [city, setCity] = useState(user?.userProfile?.city ?? '')
  const [address, setAddress] = useState(user?.userProfile?.address ?? '')
  const [education, setEducation] = useState(user?.userProfile?.education ?? '')
  const [experience, setExperience] = useState(
    user?.userProfile?.experience ?? '',
  )
  const [urlConference, setUrlConference] = useState(
    user?.userProfile?.url_conference ?? '',
  )
  const [urlConferenceForChildren, setUrlConferenceForChildren] = useState(
    user?.userProfile?.url_conference_for_children ?? '',
  )
  const [linkToVk, setLinkToVk] = useState(user?.userProfile?.link_to_vk ?? '')
  const [about, setAbout] = useState(user?.userProfile?.about ?? '')
  const [status, setStatus] = useState(user?.status)
  const [avatarPath, setAvatarPath] = useState(user?.avatar_path)
  const [roles, setRoles] = useState(user?.roles)
  const [workHours, setWorkHours] = useState(user?.workHours)
  const [createdAt, setCreatedAt] = useState(user?.created_at)

  useEffect(() => {
    setName(user?.name ?? '')
    setDepartments(user?.orgUnits ?? [])
    setTeams(user?.teams ?? [])
    setContracts(user?.contracts ?? [])
    setUserId(user?.id)
    setPhone(user?.phone ?? '')
    setEmail(user?.email ?? '')
    setSex(user?.userProfile?.sex)
    setBirthDate(user?.userProfile?.birth_date ?? '2000.01.01')
    setCity(user?.userProfile?.city ?? '')

    setAddress(user?.userProfile?.address ?? '')
    setEducation(user?.userProfile?.education ?? '')
    setExperience(user?.userProfile?.experience ?? '')
    setUrlConference(user?.userProfile?.url_conference ?? '')
    setUrlConferenceForChildren(
      user?.userProfile?.url_conference_for_children ?? '',
    )
    setLinkToVk(user?.userProfile?.link_to_vk ?? '')
    setAbout(user?.userProfile?.about ?? '')
    setStatus(user?.status)
    setAvatarPath(user?.avatar_path)
    setRoles(user?.roles)
    setWorkHours(user?.workHours)
    setCreatedAt(user?.created_at)
    setBirthDateDefault(user?.userProfile?.birth_date ?? '2000.01.01')
  }, [user])

  const [tabActive, setTabActive] = useState('employee')
  const [isModalActiveAddTime, setIsModalActiveAddTime] = useState(false)
  const [isModalActiveAddСontracts, setIsModalActiveAddСontracts] =
    useState(false)
  const [isModalActiveAddDepartments, setIsModalActiveAddDepartments] =
    useState(false)
  const [isModalActiveAddTeams, setIsModalActiveAddTeams] = useState(false)
  const [isModalActiveAddRole, setIsModalActiveAddRole] = useState(false)
  const [isModalActiveAddDirection, setIsModalActiveAddDirection] =
    useState(false)
  const [isModalActiveEditAva, setIsModalActiveEditAva] = useState(false)
  const [isModalActiveRecoverPassword, setIsModalActiveRecoverPassword] =
    useState(false)
  const [isModalActiveChengeVks, setIsModalActiveChengeVks] = useState(false)

  const [isModalActiveAddGroup, setIsModalActiveAddGroup] = useState(false)
  const [addGroupIdDerection, setAddGroupIdDerection] = useState(null)

  const [visible, setVisible] = useState(true)
  const [allowEditingName, setAllowEditingName] = useState(false)

  const [hasVksChanged, setHasVksChanged] = useState(false)

  const [bindSex] = useInputNew({
    name: 'sex',
    value: sex,
    defaultValue: true,
    onChange: (e) => setSex(e),
    placeholder: 'Пол',
    options: [
      { label: 'Женский', value: 'female' },
      { label: 'Мужской', value: 'male' },
    ],
  })

  const [bindTabsMobile] = useInputNew({
    name: 'tabs',
    value: tabActive,
    defaultValue: true,
    onChange: (e) => setTabActive(e),
    options: [
      { label: 'О сотруднике', value: 'employee' },
      { label: roleAndDepartmentsText, value: 'roles' },
      ...[showContracts && { label: 'Договор', value: 'contracts' }],
      ...[
        showWorkSchedule && { label: 'Рабочее расписание', value: 'timetable' },
      ],
    ],
  })

  const onChangeDate = (date, dateString) => {
    setBirthDate(dateString)
  }

  //получаем пользователя
  const [subjects, setSubjects] = useState([])

  const getSeminarianDirection = () =>
    usersAPI
      .directionBySeminarian({
        id: user.id,
        params: { expand: 'direction.directionGroups,seminarian' },
      })
      .then((res) => {
        setSubjects(
          res?.data?.data.map(
            ({
              id: linkId,
              direction: { name, id, directionGroups },
              rate,
              rate_group,
            }) => ({
              id,
              name,
              linkId,
              rate,
              rate_group,
              directionGroups,
            }),
          ) ?? [],
        )
      })
  useEffect(() => {
    if (user?.id !== undefined) {
      getSeminarianDirection()
    }
  }, [user?.id])

  const changeRate = (value, linkId) => {
    if (value > -1) {
      setSubjects((state) => {
        return state.map((el) => {
          if (el?.linkId == linkId) {
            return {
              ...el,
              rate: Number(value),
            }
          }
          return el
        })
      })

      clearTimeout(rateChangeTimeout1)

      rateChangeTimeout1 = setTimeout(() => {
        usersAPI
          .changeDirection({
            id: linkId,
            data: { rate: Number(value) },
          })
          .then((res) => {
            if (res.data.status === 'success') {
              addAlert({ text: 'Ставка успешно установлена' })
            }
          })
      }, 500)
    } else {
      addAlert({
        type: 'error',
        title: 'Вводить можно только числа',
        text: 'Вводить можно только числа',
      })
    }
  }

  const changeRateGroup = (value, linkId) => {
    if (value > -1) {
      setSubjects((state) => {
        return state.map((el) => {
          if (el?.linkId == linkId) {
            return {
              ...el,
              rate_group: Number(value),
            }
          }
          return el
        })
      })

      clearTimeout(rateChangeTimeoutGroup1)

      rateChangeTimeoutGroup1 = setTimeout(() => {
        usersAPI
          .changeDirection({
            id: linkId,
            data: { rate_group: Number(value) },
          })
          .then((res) => {
            if (res.data.status === 'success') {
              addAlert({ text: 'Ставка успешно установлена' })
            }
          })
      }, 500)
    } else {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Вводить можно только числа',
      })
    }
  }

  const deleteRoles = (value) => {
    const newRoles = roles?.filter((el) => {
      return !(value == el?.item_name)
    })

    usersAPI
      .updateRoles({
        id: userId,
        data: { roles: newRoles },
      })
      .then((res) => {
        if (res.data.status === 'success') {
          update('roles')
          addAlert({ title: 'Роль успешно удалена' })
        }
      })
  }

  const deleteDirection = (value) => {
    usersAPI.removeDirection({ id: value }).then((res) => {
      if (res.data.status === 'success') {
        setSubjects((state) => {
          return state.filter((el) => el.linkId !== value)
        })
        addAlert({ text: 'Курс успешно удален' })
      }
    })
  }

  const [idRemoteTime, setIdRemoteTime] = useState([])

  const remoteTime = (id) => {
    workingHours.delete(id)
    setIdRemoteTime((state) => {
      return [...state, id]
    })
  }

  const update = (params = '') => {
    if (params == 'direction') {
      getSeminarianDirection()
    }

    if (params == 'workHours') {
      usersAPI.getUser({ id: userId, expand: ['workHours'] }).then((res) => {
        setWorkHours(res.data.workHours)
      })
    }
    if (params == 'contracts') {
      usersAPI.getUser({ id: userId, expand: ['contracts'] }).then((res) => {
        setContracts(res.data.contracts)
        setStateUpdate({
          contracts: res.data.contracts,
        })
      })
    }
    if (params == 'departments') {
      usersAPI
        .getUser({ id: userId, expand: ['orgUnits.head'] })
        .then((res) => {
          setDepartments(res.data.orgUnits)
          setStateUpdate({
            orgUnits: res.data.orgUnits,
          })
        })
    }
    if (params == 'teams') {
      usersAPI.getUser({ id: userId, expand: ['teams.head'] }).then((res) => {
        setTeams(res.data.teams)
        setStateUpdate({
          teams: res.data.teams,
        })
      })
    }
    if (params == 'roles') {
      usersAPI.getUser({ id: userId, expand: ['roles'] }).then((res) => {
        setRoles(res.data.roles)
        setStateUpdate({
          roles: res.data.roles,
        })
      })
    }
  }

  const deleteContracts = (id) => {
    usersAPI.removeContract({ id }).then((res) => {
      update('contracts')
    })
  }

  const deleteEmployee = (idUser, idDepartment) => {
    departmentsApi
      .deleteEmployee({
        userId: idUser,
        unitId: idDepartment,
      })
      .then((res) => {
        if (res.data === true) {
          update('departments')
          addAlert({ text: 'Сотрудник удален из отдела' })
        }
      })
  }

  const deleteEmployeeFromTeam = (userId, teamId) => {
    teamsApi
      .deleteEmployee({
        userId: userId,
        teamId: teamId,
      })
      .then((res) => {
        if (res.data === true) {
          update('teams')
          addAlert({ text: 'Сотрудник удален из команды' })
        }
      })
  }

  const setStateUpdate = (newData = {}) => {
    if(!setState) return;
    setState((state) => {
      return state?.map((el) => {
        if (el?.id === edit) {
          return {
            ...el,
            ...newData,
          }
        } else {
          return el
        }
      })
    })
  }
  const save = async (updateVks = false) => {
    if (email) {
      usersAPI
        .upd({
          id: userId,
          data: {
            birth_date: birthDate.replace(/\./gi, '-'),
            email: email,
            phone: phone,
            sex: sex,
            city: city,
            address: address,
            education: education,
            experience: experience,
            url_conference: urlConference,
            url_conference_for_children: urlConferenceForChildren,
            link_to_vk: linkToVk,
            about: about,
            name: name,
            roles: roles,
            update_vks: updateVks,
          },
          expand: ['roles'],
        })

        .then((res) => {
          if (res.data.status === 'success') {
            setHasVksChanged(false)
            addAlert({ title: 'Профиль изменен' })
            setStateUpdate({
              name,
              phone,
              email,
            })
          } else {
            addAlert({
              type: 'error',
              title:
                'Упс! Ошибка. Попробуйте ещё раз или обратитесь к администратору',
            })
          }
        })

      if (userId === profile.id) {
        dispatch(
          actionUpdProfile({
            ...profile,
            userProfile: {
              ...profile.userProfile,
              url_conference: urlConference,
              url_conference_for_children: urlConferenceForChildren,
            },
          }),
        )
      }
    } else {
      addAlert({
        type: 'error',
        title: 'Упс! Ошибка. E-mail не заполнен',
      })
    }
  }

  const cancellation = () => {
    setEdit(null)
  }

  const authorization = () => {
    usersAPI.authorization(userId).then((response) => {
      AuthService.auth(
        response.data.user,
        response.data.token,
        response.data?.refresh_token,
      )
      window.location.href = '/'
    })
  }

  const deleteUser = () => {
    if (
      !userIdsAllowedToDeleteEmployee.includes(profile.id) &&
      selectEmployeesWhoAreAllowedDeleteEmployees
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Вам запрещено выполнять это действие',
      })
      return
    }
    usersAPI.disable({ id: userId }).then((res) => {
      if (res.data.status === 'success') {
        setVisible(false)
        addAlert({ text: 'Сотрудник успешно уволен' })
      }
    })
  }
  const restoreUser = () => {
    if (
      !userIdsAllowedToDeleteEmployee.includes(profile.id) &&
      selectEmployeesWhoAreAllowedDeleteEmployees
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Вам запрещено выполнять это действие',
      })
      return
    }
    usersAPI.restore({ id: userId }).then((res) => {
      if (res.data.status === 'success') {
        setVisible(false)
        addAlert({ text: 'Сотрудник успешно восстановлен' })
      }
    })
  }

  const [openGroups, setOpenGroups] = useState([])

  const openGroupsToggle = (id) => {
    if (openGroups.includes(id)) {
      setOpenGroups((state) => {
        return state.filter((el) => {
          return !(el === id)
        })
      })
    } else {
      setOpenGroups((state) => {
        return [...state, id]
      })
    }
  }

  const [seniorSeminarianIdModal, setSeniorSeminarianIdModal] = useState(null)
  const onChangeSeniorSeminarianResp = (classes, groups) => {
    setSeniorSeminarianIdModal(null)
    setUser((prev) => {
      return { ...prev, classes_supervisor: classes, groups_supervisor: groups }
    })
  }

  if (loading) {
    return <Preloader fullScreen="center" />
  }

  return (
    <>
      <div
        style={{
          borderBottom:
            status != 0 && allowEditing
              ? '0px solid #fff'
              : '1px solid #E7E7E8',
          display: visible ? 'flex' : 'none',
        }}
        className={
          classNames(s.item, {[s.itemBig]: big})
        }
      >
        <div className={s.firstState} style={{ alignItems: 'flex-start' }}>
          <div className={s.avatar}>
            <img src={getAvatar(user, true, avatarPath)} alt="" />
            {allowEditing && (
              <div
                className={s.editAva}
                onClick={() => {
                  setIsModalActiveEditAva(true)
                }}
              >
                <EditIcoNewDesign />
              </div>
            )}
          </div>

          <div className={`${s.info} ${s.infoEdit}`}>
            <div className={`${s.name} ${s.nameEdit}`}>
              {allowEditingName ? (
                <input
                  style={{ width: '100%' }}
                  value={name}
                  className={`backgroundNone`}
                  onInput={(e) => {
                    setName(e.currentTarget.value)
                  }}
                />
              ) : (
                name
              )}
              {allowEditing && (
                <div className={s.infoAndEditName}>
                  {allowEditingName ? (
                    <DeleteIconEmployees
                      onClick={() => {
                        setAllowEditingName((state) => !state)
                      }}
                    />
                  ) : (
                    <EditIcoNewDesign
                      onClick={() => {
                        setAllowEditingName((state) => !state)
                      }}
                    />
                  )}
                </div>
              )}
            </div>
            {/* <div className={`${s.onlineDate} backgroundNone`}>30.04.2024, 15:15</div> */}
          </div>
          <div className={s.registrationDate}>
            <div className="backgroundNone">
              Дата регистрации: {formateDate(new Date(createdAt * 1000))}
            </div>
          </div>
        </div>
        <div className={s.contentEdit}>
          {isMobile && (
            <InputSelect
              className="tabsMob"
              newDesign={true}
              {...bindTabsMobile}
            />
          )}
          {!isMobile && (
            <div className={s.tabs}>
              <button
                onClick={() => {
                  setTabActive('employee')
                }}
                className={`${styleFilter.buttonFilterNewDesign} ${
                  tabActive == 'employee'
                    ? styleFilter.buttonFilterNewDesignActive
                    : ''
                } backgroundNone`}
              >
                О сотруднике
              </button>
              <button
                onClick={() => {
                  setTabActive('roles')
                }}
                className={`${styleFilter.buttonFilterNewDesign} ${
                  tabActive == 'roles'
                    ? styleFilter.buttonFilterNewDesignActive
                    : ''
                } backgroundNone`}
              >
                {roleAndDepartmentsText}
              </button>
              {showContracts && (
                <button
                  onClick={() => {
                    setTabActive('contracts')
                  }}
                  className={`${styleFilter.buttonFilterNewDesign} ${
                    tabActive == 'contracts'
                      ? styleFilter.buttonFilterNewDesignActive
                      : ''
                  } backgroundNone`}
                >
                  Договор
                </button>
              )}
              {showWorkSchedule && (
                <button
                  onClick={() => {
                    setTabActive('timetable')
                  }}
                  className={`${styleFilter.buttonFilterNewDesign} ${
                    tabActive == 'timetable'
                      ? styleFilter.buttonFilterNewDesignActive
                      : ''
                  } backgroundNone`}
                >
                  Рабочее расписание
                </button>
              )}
            </div>
          )}
          {tabActive === 'employee' && (
            <div className={s.employee}>
              <input
                placeholder="Телефон"
                className={`backgroundNone ${s.phone}`}
                value={phone}
                onInput={(e) => {
                  setPhone(e.currentTarget.value)
                }}
              />
              <EmailVerifyWrapper
                visible={settings.requireEmployeeEmailConfirmation === '1'}
                verified={user?.is_email_confirmed === 1}
                style={{width: 'calc(20% - 4px)'}}
              >
                <input
                  placeholder="E-mail"
                  className={`backgroundNone ${s.emeil}`}
                  value={email}
                  onInput={(e) => {
                    setEmail(e.currentTarget.value)
                  }}
                  style={{width: '100%'}}
                />
              </EmailVerifyWrapper>
              {showGender && (
                <InputSelect className={s.sex} newDesign={true} {...bindSex} />
              )}
              {showBirthDate && (
                <Space direction="vertical" className={s.birthDate}>
                  <DatePicker
                    onChange={onChangeDate}
                    value={
                      birthDate
                        ? dayjs(birthDate.replace(/-/gi, '.'), dateFormat)
                        : dayjs(
                            birthDateDefault.replace(/-/gi, '.'),
                            dateFormat,
                          )
                    }
                    //defaultValue={dayjs(birthDate.replace(/-/gi, "."), dateFormat)}
                    format={dateFormat}
                    className={`backgroundNone ${s.birthDateValue}`}
                  />
                </Space>
              )}
              {showCity && (
                <input
                  placeholder="Город"
                  className={`backgroundNone ${s.city}`}
                  value={city}
                  onInput={(e) => {
                    setCity(e.currentTarget.value)
                  }}
                />
              )}
              {showRegistrationAddress && (
                <input
                  placeholder="Адрес регистрации"
                  className={`backgroundNone ${s.address}`}
                  value={address}
                  onInput={(e) => {
                    setAddress(e.currentTarget.value)
                  }}
                />
              )}
              {showEducation && (
                <input
                  placeholder="Образование"
                  className={`backgroundNone ${s.education}`}
                  value={education}
                  onInput={(e) => {
                    setEducation(e.currentTarget.value)
                  }}
                />
              )}
              {showWorkExperience && (
                <input
                  placeholder="Опыт работы"
                  className={`backgroundNone ${s.experience}`}
                  value={experience}
                  onInput={(e) => {
                    if (e.currentTarget.value > -1) {
                      setExperience(e.currentTarget.value)
                    }
                  }}
                />
              )}
              {showVksLink && (
                <>
                  <input
                    placeholder="Ссылка на ВКС"
                    className={`backgroundNone ${s.urlConference}`}
                    value={urlConference}
                    onInput={(e) => {
                      setUrlConference(e.currentTarget.value)
                      setHasVksChanged(true)
                    }}
                  />
                  {isSeparateLinksForStudentsAndTeachers && (
                    <input
                      placeholder="Ссылка на ВКС(для учащихся)"
                      className={`backgroundNone ${s.urlConference}`}
                      value={urlConferenceForChildren}
                      onInput={(e) => {
                        setUrlConferenceForChildren(e.currentTarget.value)
                        setHasVksChanged(true)
                      }}
                    />
                  )}
                </>
              )}
              {showSocialLink && (
                <input
                  placeholder="Ссылка на соц сеть"
                  className={`backgroundNone ${s.linkToVk}`}
                  value={linkToVk}
                  onInput={(e) => {
                    setLinkToVk(e.currentTarget.value)
                  }}
                />
              )}
              {!isMobile && showAboutMe && (
                <div className={s.titleEdit}>О себе:</div>
              )}
              {showAboutMe && (
                <textarea
                  placeholder={isMobile ? 'О себе' : 'Информация о себе'}
                  disabled={true}
                  value={about}
                  onInput={(e) => {
                    setAbout(e.currentTarget.value)
                  }}
                  className={`backgroundNone ${s.about}`}
                />
              )}
            </div>
          )}
          {tabActive === 'roles' && (
            <div className={s.roles}>
              {showDepartments && (
                <div className={s.departmentsWrapper}>
                  <div className={s.itemDepartment}>
                    <div className={s.itemDepartmentColumn1}>
                      <span className={s.columnTitle}>Отдел</span>
                    </div>
                    <div className={s.itemDepartmentColumn2}>
                      <span className={s.columnTitle}>Руководитель</span>
                    </div>
                    <div className={s.itemDepartmentColumn3}>
                      {allowEditing && (
                        <button
                          onClick={() => {
                            setIsModalActiveAddDepartments(true)
                          }}
                          style={{ marginLeft: 'auto', fontWeight: '600' }}
                          className={`${s.buttonAdd} backgroundNewGrey`}
                        >
                          {isMobile && <PlusIcon />}
                          {!isMobile ? `Добавить отдел` : ''}
                        </button>
                      )}
                    </div>
                  </div>
                  {departments?.map((item) => {
                    return (
                      <div key={item?.id} className={s.itemDepartment}>
                        <div className={s.itemDepartmentColumn1}>
                          {item?.name}
                        </div>
                        <div className={s.itemDepartmentColumn2}>
                          {item?.head?.name && (
                            <button
                              className={`backgroundNone ${s.backgroundNoneMobile}`}
                            >
                              {item?.head?.name}
                            </button>
                          )}
                        </div>
                        {allowEditing && (
                          <div
                            className={`${s.itemDepartmentColumn3} ${s.buttonDelete}`}
                            onClick={() => {
                              if (
                                window.confirm(
                                  'Вы уверены, что хотите удалить отдел у сотрудника?',
                                )
                              ) {
                                deleteEmployee(userId, item.id)
                              }
                            }}
                          >
                            {!isMobile ? (
                              `Удалить`
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="9"
                                height="10"
                                viewBox="0 0 9 10"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                                  fill="#020617"
                                />
                              </svg>
                            )}
                            {!isMobile && <DeleteIconEmployees />}
                          </div>
                        )}
                      </div>
                    )
                  })}
                </div>
              )}
              <div className={s.rolesWrapper}>
                <div className={s.itemRoles}>
                  <div className={s.itemRolesColumn1}>
                    <span className={s.columnTitle}>Роль</span>
                  </div>
                  {!isMobile && (
                    <>
                      <div className={s.itemRolesColumn2}>
                        <span
                          style={{ textAlign: 'center' }}
                          className={s.columnTitle}
                        >
                          Ставка / мин (индивид)
                        </span>
                      </div>
                      <div className={s.itemRolesColumn3}>
                        <span
                          style={{ textAlign: 'center' }}
                          className={s.columnTitle}
                        >
                          Ставка / час (групп)
                        </span>
                      </div>
                      <div
                        className={`${s.itemRolesColumn4} ${s.itemRolesColumn4Fix}`}
                        style={{ flexDirection: 'column' }}
                      >
                        {allowEditing && (
                          <button
                            onClick={() => {
                              setIsModalActiveAddRole(true)
                            }}
                            className="backgroundNewGrey"
                          >
                            Добавить роль
                          </button>
                        )}

                        {getInArr('seminarian', [
                          ...roles?.map((el) => {
                            return el.item_name
                          }),
                        ]) &&
                          allowEditing && (
                            <button
                              onClick={() => {
                                setIsModalActiveAddDirection(true)
                              }}
                              className="backgroundNewGrey"
                            >
                              Добавить курс
                            </button>
                          )}
                      </div>
                      <Tooltip
                        text="Чтобы педагог мог вести занятия по какому-либо курсу необходимо не только дать ему роль педагога, но и указать курсы, в которых он может преподавать"
                        width={220}
                      />
                    </>
                  )}
                  {isMobile && (
                    <div
                      className={`${s.itemRolesRigthmob} new-design-scroll new-design-scroll6`}
                    >
                      <div className={s.itemRolesColumn2}>
                        <span
                          style={{ textAlign: 'center' }}
                          className={s.columnTitle}
                        >
                          Ставка / мин (индивид)
                        </span>
                      </div>
                      <div className={s.itemRolesColumn3}>
                        <span
                          style={{ textAlign: 'center' }}
                          className={s.columnTitle}
                        >
                          Ставка / час (групп)
                        </span>
                      </div>
                      <div className={s.itemRolesColumn4}>
                        {allowEditing && (
                          <button
                            onClick={() => {
                              setIsModalActiveAddRole(true)
                            }}
                            className="backgroundNewGrey"
                          >
                            Добавить роль
                          </button>
                        )}

                        {getInArr('seminarian', [
                          ...roles?.map((el) => {
                            return el.item_name
                          }),
                        ]) &&
                          allowEditing && (
                            <button
                              onClick={() => {
                                setIsModalActiveAddDirection(true)
                              }}
                              className="backgroundNewGrey"
                            >
                              Добавить курс
                            </button>
                          )}
                      </div>
                    </div>
                  )}
                </div>
                {roles?.map((role, i) => {
                  if (role.item_name === 'seminarian' && subjects?.length) {
                    return subjects?.map((subject, subjectIndex) => {
                      return (
                        <div key={subject?.id} className={s.itemRoles}>
                          <div className={s.itemRolesColumn1}>
                            Педагог: {subject.name}
                            <div className={s.itemRolesColumn1Group}>
                              Группы{' '}
                              <ExpandDropDownList
                                style={{
                                  transform: openGroups.includes(subject?.id)
                                    ? 'rotate(90deg)'
                                    : 'rotate(0deg)',
                                }}
                                onClick={() => {
                                  openGroupsToggle(subject?.id)
                                }}
                              />
                              <div
                                style={{
                                  display: openGroups.includes(subject?.id)
                                    ? 'flex'
                                    : 'none',
                                }}
                                className={s.itemRolesColumn1Groups}
                              >
                                {subject?.directionGroups
                                  ?.filter((el) => el?.teacher_id === userId)
                                  ?.map((el) => {
                                    return (
                                      <div
                                        key={el.id}
                                        className={s.itemRolesColumn1GroupsItem}
                                      >
                                        {el?.name}
                                      </div>
                                    )
                                  })}
                                {allowEditing && (
                                  <button
                                    onClick={() => {
                                      setIsModalActiveAddGroup(true)
                                      setAddGroupIdDerection(subject?.id)
                                    }}
                                    className={s.itemRolesColumn1GroupsItemAdd}
                                  >
                                    Создать
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                          {!isMobile && (
                            <>
                              <div className={s.itemRolesColumn2}>
                                <input
                                  disabled={!allowEditing}
                                  style={{ width: '100%' }}
                                  className="backgroundNone"
                                  value={subject.rate ?? ''}
                                  onChange={(e) => {
                                    changeRate(
                                      e.currentTarget.value,
                                      subject.linkId,
                                    )
                                  }}
                                />
                              </div>
                              <div className={s.itemRolesColumn3}>
                                <input
                                  disabled={!allowEditing}
                                  style={{ width: '100%' }}
                                  className="backgroundNone"
                                  value={subject.rate_group ?? ''}
                                  onChange={(e) => {
                                    changeRateGroup(
                                      e.currentTarget.value,
                                      subject.linkId,
                                    )
                                  }}
                                />
                              </div>

                              {allowEditing && (
                                <div
                                  className={`${s.itemRolesColumn4} ${s.itemRolesColumn4Fix} ${s.buttonDelete}`}
                                  onClick={() => {
                                    if (
                                      window.confirm(
                                        'Вы уверены, что хотите удалить курс?',
                                      )
                                    ) {
                                      deleteDirection(subject.linkId)
                                    }
                                  }}
                                >
                                  {!isMobile ? (
                                    `Удалить`
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="9"
                                      height="10"
                                      viewBox="0 0 9 10"
                                      fill="none"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                                        fill="#020617"
                                      />
                                    </svg>
                                  )}
                                  {!isMobile && <DeleteIconEmployees />}
                                </div>
                              )}
                            </>
                          )}
                          {isMobile && (
                            <div
                              className={`${s.itemRolesRigthmob} new-design-scroll new-design-scroll6`}
                            >
                              <div className={s.itemRolesColumn2}>
                                <input
                                  disabled={!allowEditing}
                                  style={{ width: '100%' }}
                                  className="backgroundNone"
                                  value={subject.rate ?? ''}
                                  onChange={(e) => {
                                    changeRate(
                                      e.currentTarget.value,
                                      subject.linkId,
                                    )
                                  }}
                                />
                              </div>
                              <div className={s.itemRolesColumn3}>
                                <input
                                  disabled={!allowEditing}
                                  style={{ width: '100%' }}
                                  className="backgroundNone"
                                  value={subject.rate_group ?? ''}
                                  onChange={(e) => {
                                    changeRateGroup(
                                      e.currentTarget.value,
                                      subject.linkId,
                                    )
                                  }}
                                />
                              </div>

                              {allowEditing && (
                                <div
                                  className={`${s.itemRolesColumn4} ${s.buttonDelete}`}
                                  onClick={() => {
                                    if (
                                      window.confirm(
                                        'Вы уверены, что хотите удалить курс?',
                                      )
                                    ) {
                                      deleteDirection(subject.linkId)
                                    }
                                  }}
                                >
                                  {!isMobile ? (
                                    `Удалить`
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="9"
                                      height="10"
                                      viewBox="0 0 9 10"
                                      fill="none"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                                        fill="#020617"
                                      />
                                    </svg>
                                  )}
                                  {!isMobile && <DeleteIconEmployees />}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )
                    })
                  }
                  return (
                    <div className={s.itemRoleWrapper}>
                      <div className={s.itemRoleContent}>
                        <div className={s.itemRolesColumn1}>
                          <UserRole role={role} />
                        </div>
                        {!isMobile && (
                          <>
                            <div className={s.itemRolesColumn2}></div>
                            <div className={s.itemRolesColumn3}></div>
                          </>
                        )}
                        {allowEditing && (
                          <div
                            className={`${s.itemRolesColumn4} ${s.itemRolesColumn4Fix} ${s.buttonDelete}`}
                            onClick={() => {
                              if (
                                window.confirm(
                                  'Вы уверены, что хотите удалить роль?',
                                )
                              ) {
                                deleteRoles(role.item_name)
                              }
                            }}
                          >
                            {!isMobile ? (
                              `Удалить`
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="9"
                                height="10"
                                viewBox="0 0 9 10"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                                  fill="#020617"
                                />
                              </svg>
                            )}
                            {!isMobile && <DeleteIconEmployees />}
                          </div>
                        )}
                      </div>
                      {seniorSeminarianManager &&
                        role.item_name === 'senior-seminarian' && (
                          <>
                            <div
                              className={s.seniorSeminarianCoursesClassesField}
                              onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                setSeniorSeminarianIdModal(user.id)
                              }}
                              onMouseDown={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                              }}
                            >
                              <SeniorSeminaristResponsibilitySelect
                                selectedClasses={user?.classes_supervisor ?? []}
                                selectedGroups={user?.groups_supervisor ?? []}
                                onChange={() => {}}
                              />
                            </div>
                            <UpdateSeniorSeminarianSupervision
                              visible={!!seniorSeminarianIdModal}
                              userId={seniorSeminarianIdModal}
                              onSuccess={onChangeSeniorSeminarianResp}
                              onDismiss={() => setSeniorSeminarianIdModal(null)}
                            />
                          </>
                        )}
                    </div>
                  )
                })}
              </div>
            </div>
          )}
          {tabActive === 'contracts' && showContracts && (
            <div className={s.contracts}>
              <div className={s.contractsItem}>
                <div
                  className={`${s.contractsItemLeft} ${s.contractsItemLeftTitle}`}
                >
                  <div
                    style={{ marginTop: '0px' }}
                    className={`${s.contractsItemTilte} ${s.titleEdit}`}
                  >
                    {isMobile ? 'Название' : 'Название договора'}
                  </div>
                  <div
                    style={{
                      marginTop: '0px',
                      marginLeft: 'auto',
                      width: 'auto',
                    }}
                    className={`${s.contractsItemTilte} ${s.contractsItemTilteFile} ${s.titleEdit}`}
                  >
                    Файл
                  </div>
                  {isMobile && allowEditing && (
                    <button
                      onClick={() => {
                        setIsModalActiveAddСontracts(true)
                      }}
                      className={`backgroundNewGrey ${s.buttonAdd}`}
                    >
                      <PlusIcon />
                    </button>
                  )}
                </div>
                {!isMobile && allowEditing && (
                  <div
                    className={`${s.contractsItemRight} ${s.contractsItemRightFix}`}
                  >
                    <button
                      onClick={() => {
                        setIsModalActiveAddСontracts(true)
                      }}
                      className="backgroundNewGrey"
                    >
                      Добавить договор
                    </button>
                  </div>
                )}
              </div>

              {contracts?.map((item) => (
                <div key={item?.id} className={s.contractsItem}>
                  <div className={s.contractsItemLeft}>
                    <div
                      style={{ marginTop: '0px' }}
                      className={`${s.contractsItemTilte} ${s.titleEdit}`}
                    >
                      {item.name}
                    </div>
                    <a
                      target="_blank"
                      href={process.env.REACT_APP_PATH_FILE + item.file_path}
                      className={`backgroundNone ${s.contractsItemFile}`}
                    >
                      Файл загружен
                    </a>
                    {isMobile && allowEditing && (
                      <div
                        style={{ paddingRight: '0px' }}
                        className={`${s.contractsItemRight} ${s.buttonDelete}`}
                        onClick={() => {
                          if (
                            window.confirm(
                              'Вы уверены, что хотите удалить договор?',
                            )
                          ) {
                            deleteContracts(item?.id)
                          }
                        }}
                      >
                        {!isMobile ? (
                          `Удалить`
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="10"
                            viewBox="0 0 9 10"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                              fill="#020617"
                            />
                          </svg>
                        )}
                        {!isMobile && <DeleteIconEmployees />}
                      </div>
                    )}
                  </div>
                  {!isMobile && allowEditing && (
                    <div
                      style={{ paddingRight: '0px' }}
                      className={`${s.contractsItemRight} ${s.buttonDelete}`}
                      onClick={() => {
                        if (
                          window.confirm(
                            'Вы уверены, что хотите удалить договор?',
                          )
                        ) {
                          deleteContracts(item?.id)
                        }
                      }}
                    >
                      {!isMobile ? (
                        `Удалить`
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="9"
                          height="10"
                          viewBox="0 0 9 10"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M0.193327 0.693571C0.362554 0.524344 0.636925 0.524344 0.806153 0.693571L4.49974 4.38716L8.19333 0.693571C8.36255 0.524344 8.63693 0.524344 8.80615 0.693571C8.97538 0.862798 8.97538 1.13717 8.80615 1.3064L5.11257 4.99998L8.80615 8.69357C8.97538 8.8628 8.97538 9.13717 8.80615 9.3064C8.63693 9.47562 8.36255 9.47562 8.19333 9.3064L4.49974 5.61281L0.806153 9.3064C0.636925 9.47562 0.362554 9.47562 0.193327 9.3064C0.0240995 9.13717 0.0240995 8.8628 0.193327 8.69357L3.88691 4.99998L0.193327 1.3064C0.0240995 1.13717 0.0240995 0.862798 0.193327 0.693571Z"
                            fill="#020617"
                          />
                        </svg>
                      )}
                      {!isMobile && <DeleteIconEmployees />}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          {tabActive === 'timetable' && showWorkSchedule && (
            <div className={s.timetable}>
              {allowEditing && allowEditing && (
                <button
                  onClick={() => {
                    setIsModalActiveAddTime(true)
                  }}
                  className={`backgroundNewGrey ${s.addTimetable}`}
                >
                  Добавить расписание
                </button>
              )}
              <div className={s.timetableList}>
                {['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'].map(function (
                  weekDay,
                  index,
                ) {
                  return (
                    <Fragment key={index}>
                      <div className={s.timetableItem}>
                        <div className={s.timetableItemLeft}>
                          <div className={s.timetableItemLeftDay}>
                            {weekDay}
                          </div>
                          <div
                            className={`${s.timetableItemLeftTimeWrapper} new-design-scroll new-design-scroll6`}
                          >
                            {workHours?.map(function (item) {
                              if (item.week_day === index) {
                                if (!idRemoteTime.includes(item.id)) {
                                  return (
                                    <Fragment key={item.id}>
                                      <div className={s.timetableItemLeftTime}>
                                        {item.start_time.slice(0, 5)} -{' '}
                                        {item.end_time.slice(0, 5)}
                                        {allowEditing && (
                                          <span
                                            className={
                                              s.timetableItemLeftTimeDeleteIcon
                                            }
                                            onClick={(event) => {
                                              if (
                                                window.confirm(
                                                  'Вы уверены, что хотите удалить эти часы работы?',
                                                )
                                              ) {
                                                remoteTime(item.id)
                                              }
                                            }}
                                          >
                                            <DeleteIconEmployees />
                                          </span>
                                        )}
                                      </div>
                                    </Fragment>
                                  )
                                }
                              }
                            })}
                          </div>
                        </div>
                      </div>
                    </Fragment>
                  )
                })}
              </div>
            </div>
          )}
        </div>
        {allowEditing && (
          <div className={s.actionsWithTheUser}>
            {status != 0 && (
              <button
                onClick={() => {
                  if (hasVksChanged) {
                    setIsModalActiveChengeVks(true)
                  } else {
                    save()
                  }
                }}
                style={{
                  borderLeft: 'none',
                  borderTopLeftRadius: '0px',
                  borderTopRightRadius: '0px',
                }}
                className={`${s.actionsWithTheUserButton} ${s.actionsWithTheUserButtonSave}`}
              >
                Сохранить
              </button>
            )}
            {status != 0 && (
              <button
                onClick={cancellation}
                style={{
                  borderTopRightRadius: '0px',
                  borderTopLeftRadius: '0px',
                }}
                className={s.actionsWithTheUserButton}
              >
                Закрыть
              </button>
            )}
            {status != 0 && (
              <button
                onClick={() => {
                  setIsModalActiveRecoverPassword(true)
                }}
                style={{
                  borderTopRightRadius: '0px',
                  borderTopLeftRadius: '0px',
                }}
                className={`${s.actionsWithTheUserButton} ${s.actionsWithTheUserButtonPassword}`}
              >
                Сбросить пароль
              </button>
            )}
            {status != 0 && (
              <button
                onClick={authorization}
                style={{
                  borderTopRightRadius: '0px',
                  borderTopLeftRadius: '0px',
                }}
                className={`${s.actionsWithTheUserButton} ${s.actionsWithTheUserButtonAuthorization}`}
              >
                Авторизоваться
              </button>
            )}
            {status != 0 && (
              <button
                onClick={deleteUser}
                disabled={
                  !userIdsAllowedToDeleteEmployee.includes(profile.id) &&
                  selectEmployeesWhoAreAllowedDeleteEmployees
                }
                style={{
                  borderRight: 'none',
                  borderTopRightRadius: '0px',
                  borderTopLeftRadius: '0px',
                }}
                className={`${s.actionsWithTheUserButton} ${s.actionsWithTheUserButtonDelete}`}
              >
                Уволить
              </button>
            )}
            {status == 0 && (
              <button
                onClick={restoreUser}
                disabled={
                  !userIdsAllowedToDeleteEmployee.includes(profile.id) &&
                  selectEmployeesWhoAreAllowedDeleteEmployees
                }
                style={{
                  borderBottom: 'none',
                  borderLeft: 'none',
                  borderTopRightRadius: '0px',
                  borderTopLeftRadius: '0px',
                }}
                className={s.actionsWithTheUserButton}
              >
                Восстановить
              </button>
            )}
          </div>
        )}
        {!allowEditing && status != 0 && (
          <div className={s.actionsWithTheUser}>
            <button
              onClick={cancellation}
              style={{
                borderTopRightRadius: '0px',
                borderTopLeftRadius: '0px',
                borderBottom: '0px',
                borderLeft: '0px',
              }}
              className={s.actionsWithTheUserButton}
            >
              Закрыть
            </button>
          </div>
        )}
      </div>
      {isModalActiveAddTime && (
        <Modal
          active={isModalActiveAddTime}
          setActive={() => setIsModalActiveAddTime(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddTime(false)}
          />
          <ModalAddTime
            setActive={setIsModalActiveAddTime}
            userId={userId}
            update={update}
          />
        </Modal>
      )}
      {isModalActiveAddСontracts && (
        <Modal
          active={isModalActiveAddСontracts}
          setActive={() => setIsModalActiveAddСontracts(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddСontracts(false)}
          />
          <ModalAddContracts
            setActive={setIsModalActiveAddСontracts}
            userId={userId}
            update={update}
          />
        </Modal>
      )}
      {isModalActiveAddDepartments && (
        <Modal
          active={isModalActiveAddDepartments}
          setActive={() => setIsModalActiveAddDepartments(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddDepartments(false)}
          />
          <ModalAddDepartments
            setActive={setIsModalActiveAddDepartments}
            userId={userId}
            departments={departments}
            update={update}
          />
        </Modal>
      )}
      {isModalActiveAddTeams && (
        <Modal
          active={isModalActiveAddTeams}
          setActive={() => setIsModalActiveAddTeams(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddTeams(false)}
          />
          <ModalAddTeams
            setActive={setIsModalActiveAddTeams}
            userId={userId}
            teams={teams}
            update={update}
          />
        </Modal>
      )}
      {isModalActiveAddRole && (
        <Modal
          active={isModalActiveAddRole}
          setActive={() => setIsModalActiveAddRole(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddRole(false)}
          />
          <ModalAddRole
            setActive={setIsModalActiveAddRole}
            userId={userId}
            rolesUser={roles}
            update={update}
          />
        </Modal>
      )}
      {isModalActiveAddDirection && (
        <Modal
          active={isModalActiveAddDirection}
          setActive={() => setIsModalActiveAddDirection(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddDirection(false)}
          />
          <ModalAddDirection
            setActive={setIsModalActiveAddDirection}
            userId={userId}
            subjects={subjects}
            update={update}
          />
        </Modal>
      )}
      {isModalActiveRecoverPassword && (
        <Modal
          active={isModalActiveRecoverPassword}
          setActive={() => setIsModalActiveRecoverPassword(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveRecoverPassword(false)}
          />
          <ModalRecoverPassword
            setActive={setIsModalActiveRecoverPassword}
            userId={userId}
          />
        </Modal>
      )}
      {isModalActiveEditAva && (
        <Modal
          active={isModalActiveEditAva}
          setActive={() => setIsModalActiveEditAva(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveEditAva(false)}
          />
          <ModalEditAva
            setActive={setIsModalActiveEditAva}
            userId={userId}
            setAvatarPath={setAvatarPath}
            avatarPath={avatarPath}
            setStateUpdate={setStateUpdate}
          />
        </Modal>
      )}
      {isModalActiveAddGroup && (
        <Modal
          active={isModalActiveAddGroup}
          setActive={() => setIsModalActiveAddGroup(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveAddGroup(false)}
          />
          <ModalAddGroup
            setActive={setIsModalActiveAddGroup}
            userId={userId}
            update={update}
            direction={addGroupIdDerection}
          />
        </Modal>
      )}
      {isModalActiveChengeVks && (
        <Modal
          active={isModalActiveChengeVks}
          setActive={() => setIsModalActiveChengeVks(false)}
        >
          <IcoRemove
            className={s.modalProfileIconClose}
            onClick={() => setIsModalActiveChengeVks(false)}
          />
          <ModalChengeVks setActive={setIsModalActiveChengeVks} save={save} />
        </Modal>
      )}
    </>
  )
}

const UserRole = ({ role }) => useGetNameRole(role)

export default CollegesItemEdit
